import { FishHeaderStyles } from './FishHeader.types'

const makeStyles = (): FishHeaderStyles => ({
	fishHeader: {
		margin: '0px 0px 50px 0px'
	}
})

export default makeStyles
